import { Navigate } from "react-router-dom";
import { decryptObject } from "./components/GlobalFunction";

const RouteGuard = ({ element, allowedUserTypes, module }) => {
  const encryptedSession = sessionStorage.getItem("sessioninfo");

  let sessionData = {};
  try {
    sessionData = encryptedSession ? decryptObject(encryptedSession) : {};
  } catch (err) {
    sessionData = {};
  }

  const isAuthenticated = !!sessionData?.accessToken;
  const userType = sessionData?.userType;
  const isVerified = sessionStorage.getItem("isVerified");

  let authorized = allowedUserTypes?.map(Number)?.includes(Number(userType));

  // When this route maps to a Roles permission module, prefer that over the
  // old hardcoded userType list -- same rule Sidebar.js already uses to
  // decide what to show, so a role that can see an item in the sidebar can
  // also actually open it (and one that can't, gets the same answer both
  // places instead of the sidebar saying yes and the route saying no).
  if (module) {
    try {
      const raw = sessionStorage.getItem("permissions");
      if (raw) {
        const permissions = JSON.parse(raw);
        authorized = (permissions[module] || []).includes("show");
      }
      // No cached permissions yet -- fall back to allowedUserTypes above
      // rather than failing closed on a timing gap.
    } catch (err) {
      // Parse failure -- keep the allowedUserTypes fallback.
    }
  }

  if (isAuthenticated && authorized && isVerified) {
    return element;
  }

  return (
    <Navigate to="/login" replace state={{ from: window.location.pathname }} />
  );
};

export default RouteGuard;
